import {
  Auth_UserLogoutMutation,
  Auth_UserLogoutMutationVariables,
} from '@/types';
import { AuthService } from '@domain/auth/blocs/services/auth-service';
import { captureException } from '@/utils/sentry';
import { gql, useMutation } from '@apollo/client';
import { partnerSupplier } from '@/utils/environment';
import { useCallback } from 'react';
import { useExperienceStore } from '@/stores/experience-store';

export const LOGOUT_MUTATION = gql`
  mutation Auth_UserLogout($businessOrganizationUUID: uuid!) {
    restaurantEmployeeLogout(
      business_organization_id: $businessOrganizationUUID
    ) {
      employee_id
    }
  }
`;

export const useSignOut = () => {
  const { cleanupOnLogout } = useExperienceStore();

  const [logout] = useMutation<
    Auth_UserLogoutMutation,
    Auth_UserLogoutMutationVariables
  >(LOGOUT_MUTATION);

  return useCallback(async () => {
    // Fire-and-forget the logout mutation before signing out
    logout({
      variables: {
        businessOrganizationUUID: partnerSupplier.businessOrganizationUUID,
      },
    }).catch(captureException);

    cleanupOnLogout();
    await AuthService.signOut();
  }, [cleanupOnLogout, logout]);
};
